export type ENVIRONMENT = "development" | "test" | "staging" | "production";

const HOSTNAME_TO_ENVIRONMENT: Record<string, ENVIRONMENT> = {
  "digicgt.roqua.nl": "production",
  "digicgt.roqua-staging.nl": "staging",
  "digicgt.roqua.eu": "development",
  "digicgt.roqua.local": "development",
  localhost: "development",
};

export function getEnvironment(): ENVIRONMENT {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    const env = HOSTNAME_TO_ENVIRONMENT[hostname];

    if (env) {
      return env;
    }
  }

  // Fallback to production if no match is found, which has
  // the least chance of breaking production.
  return "production";
}

export const environment = getEnvironment();
